import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Pane from '../components/Pane'

@inject('museum', 'auth') @observer
class PaneContainer extends Component {

  static propTypes = {
    auth: PropTypes.object,
    museum: PropTypes.object,
  }

  componentWillMount() {
    const { museum, auth: { user } } = this.props
    if (!museum.getById(user.museumId * 1)) {
      museum.load(user.museumId)
    }
  }

  render() {
    const { museum, auth: { user } } = this.props

    const current = user.museumId
      ? museum.getById(user.museumId * 1)
      : null

    if (!current) {
      return null
    }
    return (
      <Pane data={current} />
    )
  }

}

const PaneContainerWithRouter = withRouter(PaneContainer)

export { PaneContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/museum/containers/Pane.js